export const uiUxDesigner = {
  id: 'ui-ux-designer',
  version: 2,
  renderer: 'enterprise',
  name: 'UI/UX Designer Portfolio',
  layout: 'two-column',
  theme: 'modern-teal',
  persona: ['creative'],
  atsLevel: 'B',
  scoreWeights: {
    ats: 25,
    visual: 50,
    executive: 10,
    student: 15
  },
  sectionOrder: ['personal-info', 'summary', 'projects', 'experience', 'education', 'skills', 'languages'],
  components: {
    header: 'header-classic',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-section'
  },
  metadata: {
    industry: ['Product Design', 'Tech Startups', 'Design Agencies'],
    companies: ['Figma', 'Canva', 'Adobe', 'Airbnb', 'Apple', 'Slack', 'Vercel'],
    ats: ['Lever', 'Greenhouse', 'Ashby'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    density: 'comfortable',
    columns: 2,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    recommendedFor: ['UI/UX Designers', 'Product Designers', 'Visual Designers', 'Interaction Designers'],
    avoidFor: ['Investment Bankers', 'Systems Engineers', 'Federal Employees'],
    dna: ['Visual-Design', 'Teal-Highlights', 'Two-Column-Modern', 'Dribbble-Behance-Native', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 88,
      scanningSpeed: 89,
      visualAppeal: 98
    },
    hiringManager: {
      firstImpression: "Highly creative design professional with a polished aesthetic sense and case study links",
      scanningStyle: "Two-column visual scan focusing on portfolio links, design tools stack, and user flow metrics",
      preferredStructure: "Summary and projects in main body; education, skills, and languages in sidebar",
      dislikes: ["Wall of text resumes", "Dry technical jargon", "No link to Behance/Dribbble/Portfolio"]
    },
    strategy: {
      goal: "Hook product design managers with a high-aesthetic layout that showcases design links and skills cards",
      focus: "User experience metrics (adoption, satisfaction), interaction tools stack (Figma, Adobe XD)",
      avoid: ["Traditional serif layouts", "Dense text formatting"]
    },
    psychology: {
      coreTraits: ["Creativity", "Aesthetic perfection", "User-empathy", "Modernity"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Highlight design methodologies (e.g. wireframing, user testing). Mention product design metrics (e.g. 'increased user adoption rate by 35%'). Use active design terms.",
      rewriteStyle: "Creative, user-focused, product design style"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'languages', 'education'],
        main: ['summary', 'projects', 'experience']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '3px',
    '--bullet-style': 'circle',
    '--spacing-section-mb': '20px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2C3E50',
    '--color-text-light': '#7F8C8D'
  }
};
export default uiUxDesigner;
